export default "__VITE_ASSET__CEgCksOA__"